import { ShareBaseItem } from 'phoenix/domain';
import { 
	IDictionary, 
	Action,
	OneOrMany,
	AsyncOpHandle 
} from 'util/domain';
import { 
	DownloadService,
	DownloadOpHandle 
} from 'sharebase/services/downloadService';
import { PendingActionsService } from 'sharebase/services/pendingActionsService';
import { ToastService } from 'sharebase/services/toastService';

/**
 * Supports downloading multiple files at the same time using the async download methods.
 */
export class DownloadDataStore {
	public static readonly $inject: string[] = [
		'$timeout',
		'sbToastService',
		'sbDownloadService',
		'sbPendingActionsService',
		'gettextCatalog'
	];

	private readonly pendingMessage: string;
	private resolvePendingMessage: Action;

	constructor(
		private readonly $timeout:ng.ITimeoutService,
		private readonly sbToastService:ToastService,
		private readonly sbDownloadService:DownloadService,
		private readonly sbPendingActionsService:PendingActionsService,
		private readonly gettextCatalog:ng.gettext.gettextCatalog
	) {
		this.pendingMessage = gettextCatalog.getString('You have a download in progress');
	}

	public downloadItems(items:OneOrMany<ShareBaseItem>, context:string) {
		return this.sbDownloadService
			.downloadItems(items, context)
			.then(handle => {
				if(handle){					
					return this.processHandle(handle, context);
				}
			});		
	}

	private showPendingMessage() {
		if (!this.resolvePendingMessage) {
			this.resolvePendingMessage = this.sbPendingActionsService.addMessage(this.pendingMessage, 'DOWNLOAD IN PROGRESS');
		}
	}

	private processHandle(handle:DownloadOpHandle, context:string) {
		this.showPendingMessage();

		let message = this.gettextCatalog.getString('Generating zip file for {{fileName}} download', { fileName: context })
		let resolveToast = this.sbToastService.showProgressMessage({
			message,
			cancelFn: () => handle.cancel()
		});

		return handle.status
			.then(result => {
				if (typeof result === 'string') {
					// disable messages so there's no warning if multiple files are being downloaded.
					let disabled = this.sbPendingActionsService.disablePendingMessages();
					this.sbDownloadService.downloadByUri(result, context);
					resolveToast();
					resolveToast = undefined;

					this.$timeout(() => disabled(), 250);
				}
			})
			.finally(() => {
				if (resolveToast) {
					resolveToast();
				}

				if (this.resolvePendingMessage && !this.sbDownloadService.hasPendingDownloads) {
					this.resolvePendingMessage();
					this.resolvePendingMessage = undefined;
				}
			});		
	}


}


// WEBPACK FOOTER //
// ./src/sharebase-app/dataStores/downloadDataStore.ts